<template>
  <div class="look-base">
    <user-detail-title
      first-bread="标签管理"
      second-bread="产品信息"
      third-bread="产品信息查看"
      first-url="/user/sign"
      second-url="/user/product_info"
      title-name="产品信息查看"
    ></user-detail-title>
    <user-detail-base>
      <el-form label-position="left" label-width="100px" v-if="LookData">

        <el-form-item label="名称">
          <p>{{ LookData.name }}</p>

        </el-form-item>
        <el-form-item label="主图">
          <el-image class="item-image" :src="'http://'+LookData.photoUrl" alt=""></el-image>
        </el-form-item>
        <el-form-item label="型号">
          <p>{{ LookData.name }}</p>
        </el-form-item>
        <el-form-item label="品牌">
          <el-checkbox-group :value="true" v-if="LookData">
            <el-checkbox v-for="  (item,index) in LookData.labelList" :key="index+'s2'" disabled >
              {{item.name}}
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="型号">
          <el-checkbox-group :value="true" v-if="LookData">
            <el-checkbox v-for="  (item,index) in LookData.classifyList" :key="index+'s1'" disabled>
              {{item.name}}
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="商品介绍">
          <p>{{ LookData.productIntroduce }}</p>
        </el-form-item>
        <el-form-item label="创建时间">
          <p>{{ LookData.createTime }}</p>
        </el-form-item>
        <el-form-item label="更新时间">
          <p>{{ LookData.updateTime }}</p>
        </el-form-item>
      </el-form>
    </user-detail-base>
  </div>
</template>

<script>
  import UserDetailTitle from "../Common/UserDetailTitle";
  import UserDetailBase from "@/views/User/Common/UserDetailBase";
  export default {
    name: "ProductInfoLook",
    components: {UserDetailBase, UserDetailTitle},
    data(){
      return{
        LookData:null,

      }
    },
    created() {
      this.GetLookData(this.$route.params.id)
    },
    methods:{
      GetLookData(id){
        this.$axios.get('/api/productInfo/getById',{params:{
          id:id
          }}).then(res=>{
          // console.log(res);
          this.LookData=res.data.data
        })
      }
    }
  }
</script>

<style lang="less" scoped>

</style>